/**
 * Custom Reviews Slider
 */
if (!customElements.get("custom-review-slider")) {
  class CustomReviewsSlider extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * Called when the element is attached to the DOM.
     * Initializes event listeners and properties.
     */
    connectedCallback() {
      this.container = this.querySelector(".custom-review-slider");
      this.sliderCounter = +this.container.dataset.slidesCounter;
      this.sliderAutoplay = this.container.dataset.sliderAutoplay;
      this.sliderUseArrows = this.container.dataset.sliderUsearrows;
      this.sliderUseDots = this.container.dataset.sliderUsedots;
      this.sliderWrapAround = this.sliderAutoplay === "true";

      this.sliderSettings = {
        pageDots: this.sliderUseDots === "true",
        prevNextButtons: this.sliderUseArrows === "true",
        autoPlay: this.sliderAutoplay === "true",
        pauseAutoPlayOnHover: false,
        contain: true,
        draggable: false,
        wrapAround: this.sliderWrapAround,
      };

      if (this.sliderCounter > 3) this.setupSlider();
    }

    /**
     * Called when the element is detached from the DOM.
     * Removes event listeners.
     */
    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy();
      }
    }

    async setupSlider() {
      try {
        this.slider = await window.setupFlickity(
          this.container,
          this.sliderSettings
        );
      } catch (error) {
        console.error(
          `❌ 👉🏻 CustomReviewsSlider | setupSlider | ${error.message}`
        );
        throw error;
      }
    }
  }

  customElements.define("custom-review-slider", CustomReviewsSlider);
}
